<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="selectedUrl ? `/request/${inputs.id}` : '/request'"
      >
        <div class="row">
          <div class="col-md-12">
            <app-note
              class="mb-primary"
              title="Información"
              content-type="html"
              :notes="[$store.getters.getTag('2.O')]"
            />
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Sector</label>
              <multiselect
                v-model="inputs.level2"
                :options="scopes.level2"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Norma de acreditación</label>
              <multiselect
                v-model="inputs.level3"
                :options="scopes.level3"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Norma de certificación</label>
              <multiselect
                v-model="inputs.level4"
                :options="scopes.level4"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Sector/Referencia</label>
              <multiselect
                v-model="inputs.level5"
                :options="scopes.level5"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Actividad</label>
              <multiselect
                v-model="inputs.level6"
                :options="scopes.level6"
                placeholder="Seleccione una opción"
                label="value"
              ></multiselect>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Condición de Alcance </label>
              <app-input
                type="select"
                v-model="inputs.condicion_scope"
                :required="true"
                :list="condicionList"
                v-on:change="getResolution(inputs.condicion_scope)"
              />
            </div>
          </div>
          <div class="col-12" v-if="nameResolution=='Suspensión' || nameResolution=='Suspensión voluntaria' || nameResolution=='Retiro' || nameResolution=='Retiro voluntario' || nameResolution=='Reducción' || nameResolution=='Reducción voluntaria'">
            <div class="form-group">
              <label>Fecha a {{nameResolution}}
              </label>
              <app-input
                type="date"
                v-model="inputs.updated_at"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import Multiselect from "vue-multiselect";
import LiquorTree from "liquor-tree";
import { axiosGet } from "@/app/helpers/AxiosHelper";


export default {
  components: { Multiselect, LiquorTree },
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      scopes: {
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      },
      modalId: "add-edit-modal",
      disabledSubmit: false,
      condicionList: [],
      nameResolution: "",
      isResolution: 0,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    this.getResolutionList();
    this.getData();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    getResolutionList() {
      axiosGet("/resolutionList").then((resp) => {
        this.condicionList = resp.data;
      });
    },
    submit() {
      const tmp = {
        ...this.inputs,
        acc_app_id: this.$store.state.accreditation.id,
      };
      
      tmp.level2 = this.getId(tmp.level2);
      tmp.level3 = this.getId(tmp.level3);
      tmp.level4 = this.getId(tmp.level4);
      tmp.level5 = this.getId(tmp.level5);
      tmp.level6 = this.getId(tmp.level6);
      tmp.is_resolution = this.isResolution;
      tmp.status_scope = 'information';

      // Validar multi-select
      if (!tmp.level2 || !tmp.level3 || !tmp.level4 || !tmp.level5 || !tmp.level6) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      if (this.isResolution && !tmp.updated_at) {
        this.$toastr.e("Todos los campos son obligatorios");
        return;
      }

      this.disabledSubmit = true;
      this.save(tmp);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;

      const tmp = {};
      tmp.id = response.data.id;
      
      tmp.level2 = response.data.level_2;
      tmp.level3 = response.data.level_3;
      tmp.level4 = response.data.level_4;
      tmp.level5 = response.data.level_5;
      tmp.level6 = response.data.level_6;
      tmp.condicion_scope = response.data.condicion_scope;
      this.getResolution(response.data.condicion_scope);
      tmp.updated_at = new Date(response.data.updated_at);
      
      this.inputs = tmp;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const { scopes } = response.data;
            this.scopes = scopes;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getId(item) {
      return item ? item.id : null;
    },

    getResolution(id) {
      this.isResolution = 0;
      this.axiosGet(
        `request/resolutionTypes/${id}`
      )
        .then((response) => {
             this.nameResolution = response.data.name;

             if (this.nameResolution=='Suspensión' || this.nameResolution=='Suspensión voluntaria') {
                this.isResolution = 1;
             } else if (this.nameResolution=='Retiro' || this.nameResolution=='Retiro voluntario') {
                this.isResolution = 2;
             } else {
                this.isResolution = 0;
             }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
      return this.nameResolution;
    }
  },
};
</script>
